const progress = [
    "position2",
    "position1",
    "position3",
    "position4",
    "position5",
    "position6",
    "position7",
];

export default progress;
